import { atom, useAtom, useSetAtom } from "jotai";

export type WaiterView = "tables" | "menu";

const waiterViewAtom = atom<WaiterView>("tables");

const useWaiterView = () => {
  const atom = useAtom(waiterViewAtom);
  return atom;
};

export const useSetWaiterView = () => useSetAtom(waiterViewAtom);

export default useWaiterView;
